import { render, staticRenderFns } from "./plan-add.vue?vue&type=template&id=41041a94&scoped=true&"
import script from "./plan-add.vue?vue&type=script&lang=js&"
export * from "./plan-add.vue?vue&type=script&lang=js&"
import style0 from "./plan-add.vue?vue&type=style&index=0&id=41041a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41041a94",
  null
  
)

export default component.exports